import * as React from "react";
import { WandSparkles } from "lucide-react";
import { Button } from "@/components/ui";
import { DesignPackageSummary } from "@/services/bedrock/dtos/DesignPackage";
import { InspirationStrip, useInspirationPackages } from "./InspirationStrip";

export interface PackageEmptyStateProps {
  onNewDesign(): void;
  canEdit: boolean;
  onPreviewTemplate(pkg: DesignPackageSummary): void;
  onViewAll(): void;
  /** Admin Coach scope shows the hero alone. */
  hideInspiration?: boolean;
}

export const PackageEmptyState: React.FC<PackageEmptyStateProps> = ({
  onNewDesign,
  canEdit,
  onPreviewTemplate,
  onViewAll,
  hideInspiration,
}) => {
  const { data } = useInspirationPackages(!hideInspiration);
  const hasGlobals = !hideInspiration && (data?.content.length ?? 0) > 0;

  return (
    <div className="flex flex-col gap-6" data-testid="package-empty-state">
      {hasGlobals && (
        <>
          <InspirationStrip expanded onPreview={onPreviewTemplate} onViewAll={onViewAll} />
          <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
            <span className="h-px flex-1 bg-slate-200" />
            or
            <span className="h-px flex-1 bg-slate-200" />
          </div>
        </>
      )}
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border p-12 text-center bg-card shadow-sm">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 mb-6 text-primary">
          <WandSparkles className="h-10 w-10" aria-hidden="true" />
        </div>
        <h3 className="text-2xl font-bold tracking-tight mb-2">Design once. Post everywhere.</h3>
        <p className="text-muted-foreground max-w-md mx-auto mb-8">
          Describe a look, and Design Studio builds a template your players can turn into personalized posts with their
          own name, headshot, and branding.
        </p>
        {canEdit && (
          <Button size="lg" onClick={onNewDesign}>
            Create your first design
          </Button>
        )}
      </div>
    </div>
  );
};
